var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.14965 10.0329L7.31918 11.2024L3.28888 15.2327L2.11934 14.0632L6.14965 10.0329ZM8.6975 7.48501L9.58955 7.76197L9.86704 8.65455L7.99278 10.5288L6.82324 9.35927L8.6975 7.48501ZM16.1758 1.17576L12.2727 2.50255L8.96533 0.0346695L9.01847 4.15729L5.65156 6.53876L7.67074 7.16244L0.771615 14.0616L3.28995 16.5799L10.1891 9.68078L10.8128 11.7L13.1942 8.33305L17.3174 8.38672L14.8511 5.081L16.1758 1.17576Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagic);
export default __webpack_public_path__ + "static/media/magic.2740b04bf565a2481238f224fb154de7.svg";
export { ForwardRef as ReactComponent };